
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class ProdottiSmtpDialog extends Serenity.EntityDialog<ProdottiRow, any> {
        protected getFormKey() { return ProdottiSmtpForm.formKey; }
        protected getIdProperty() { return ProdottiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiRow.nameProperty; }
        protected getService() { return ProdottiService.baseUrl; }
        protected getDeletePermission() { return ProdottiRow.deletePermission; }
        protected getInsertPermission() { return ProdottiRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiRow.updatePermission; }

        protected form = new ProdottiSmtpForm(this.idPrefix);

        constructor() {
            super();


            //$('<a class="inplace-button inplace-invia-mail-test"><b><i class="fa fa-envelope-o text-red"></i></b></a>')
            //    .attr("title", "Invia mail di test")
            //    .insertAfter(this.form.InviaMailTest.element)
            //    .click(e => {

            //        if (this.form.SMTPHost.value === "") {
            //            Q.warning("Per utilizzare queste funzionalità di SMTP, occorre inserire le informazioni necessarie per connettersi al server di posta desiderato!");
            //            return;
            //        }

            //        if (this.entity.IsSMTPValido !== 1) {
            //            Q.warning("Per inviare la mail di test, occorre prima salvare tutti i dati inseriti e, poi, attivare questo progetto!");
            //            return;
            //        }

            //    });
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }       

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.dialogTitle = "Parametri SMTP del prodotto";
        }
    }
}
